export * as ACTIVE_ROLES from './activeRoles';
export * as APPLICANTS from './applicants';
export * as APPLICATION_DATA_COLLECTION from './applicationDataCollection';
export * as APPLICATIONS from './applications';
export * as ASSETS from './assets';
export * as AUTHENTICATION from './authentication';
export * as BROKER_INTERVIEWS from './brokerInterviews';
export * as BROKER_INTERVIEWS_GUARANTOR from './brokerInterviewsGuarantor';
export * as COMPANIES from './companies';
export * as CONVEYANCING from './conveyancing';
export * as CREDIT_REPORTS from './creditReports';
export * as CUSTOMERS from './customers';
export * as EMPLOYMENTS from './employments';
export * as EXPENSES from './expenses';
export * as FINANCIAL_SITUATIONS from './financialSituations';
export * as INCOMES from './incomes';
export * as INVITATIONS from './invitations';
export * as LEAD from './lead';
export * as LIABILITIES from './liabilities';
export * as OTHER from './other';
export * as POST_PRODUCT_SELECT from './postProductSelect';
export * as PRODUCT_PREFERENCES from './productPreferences';
export * as PRODUCT_SELECTIONS from './productSelections';
export * as RELATED_PARTY from './relatedParty';
export * as REQUIRED_ACTION_CONDITIONS from './requiredActionConditions';

export enum SHARED_ACTION_TYPES {
  CLEAR_DATA = 'CLEAR_DATA',
  CLEAR_ERROR = 'CLEAR_ERROR',
}
